import { useEffect } from 'react';
import { VStack, Heading, Text } from 'components/ui';
import { Box } from '@chakra-ui/react';
import { useTracking } from '../../hooks/useTracking';

import HeaderNav from '../HeaderNav/HeaderNav';
import { Link } from '../ui/Link';
import { useLocation, useNavigate } from 'react-router-dom';

const TRACK_INELIGIBLE_PAGE = 'ineligible_page';

export const Ineligible = () => {
  const { page: pageView } = useTracking();
  const { state } = useLocation();
  const navigate = useNavigate();
  const ineligibleHeading =
    state?.heading || 'Sorry, Ayble isn’t covered for you just yet';
  const ineligibleReason =
    state?.message ||
    "We're sorry, but we were unable to verify your eligibility with your health plan details.";

  useEffect(() => {
    pageView(TRACK_INELIGIBLE_PAGE);
  }, [pageView]);

  const supportLinkProps = {
    color: 'aqua.500',
    fontWeight: 600,
    display: 'inline',
    textDecoration: 'none',
    _hover: { textDecoration: 'underline' },
  } as const;

  const renderContent = () => {
    return (
      <VStack alignItems={'center'} gap={'22px'} maxW={'formWidth'} w={'100%'}>
        <Heading
          textStyle="heading.h2"
          color={'secondary.500'}
          textAlign={'center'}
        >
          {ineligibleHeading}
        </Heading>

        <Text
          color={'blueGray.600'}
          fontSize={'14px'}
          lineHeight={'1.55'}
          maxW={'44ch'}
          textAlign={'center'}
        >
          {ineligibleReason}
        </Text>

        {/* This screen is only a heading and one line, so the support block
            gets real separation instead of the standard 22px gap. */}
        <VStack alignItems={'center'} gap={'8px'} maxW={'340px'} mt={'46px'}>
          <Text
            color={'blueGray.600'}
            fontSize={'12.5px'}
            fontWeight={700}
            textAlign={'center'}
          >
            Need Help?
          </Text>

          <Text
            color={'blueGray.600'}
            fontSize={'12.5px'}
            lineHeight={'1.55'}
            textAlign={'center'}
          >
            You can{' '}
            <Link
              {...supportLinkProps}
              onPress={() => {
                navigate('/eligibility', {
                  state: {
                    userId: state?.userId,
                  },
                });
              }}
              isExternal={false}
              _text={{ textTransform: 'none' }}
            >
              try entering your health plan details
            </Link>{' '}
            if you think there might be a mistake.
          </Text>

          <Text
            color={'blueGray.600'}
            fontSize={'12.5px'}
            lineHeight={'1.55'}
            textAlign={'center'}
          >
            Or you can reach out to us at{' '}
            <Link
              {...supportLinkProps}
              href="mailto:support@ayblehealth.com"
              _text={{ textTransform: 'none', fontWeight: '400' }}
            >
              support@ayblehealth.com
            </Link>{' '}
            or (857) 416-9299
          </Text>
        </VStack>
      </VStack>
    );
  };

  return (
    <Box h={'100vh'}>
      <HeaderNav />

      <VStack alignItems={'center'} px={'20px'} pt={'40px'} pb={'72px'}>
        {renderContent()}
      </VStack>
    </Box>
  );
};

export default Ineligible;
